import React from 'react';
import Confirmation from '../../../components/Forms/Confirmation';

const Init = ({updateDeliveryStatus, setPath}) => <Confirmation
  message='Gostaria de mudar o estado do frete para "Em Andamento"?'
  onSubmit={updateDeliveryStatus}
  onClose={() => setPath('root')}
/>;

export default Init;
